// =============================================================================
// SIREPPAR - Botón campanita en el header con contador de alertas pendientes
// =============================================================================

import { useNavigate } from 'react-router-dom';
import { useAlertasUsuario } from '../../hooks/useAlertasPartido';

export default function CampanaAlertas() {
  const navigate = useNavigate();
  const { data } = useAlertasUsuario();
  const total = data?.total ?? 0;

  // Si el endpoint no aplica al rol (hook deshabilitado), no renderizar nada.
  if (!data) return null;

  const handleClick = () => {
    navigate('/dashboard#alertas');
    setTimeout(() => {
      const el = document.getElementById('alertas');
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 50);
  };

  const tieneAlertas = total > 0;
  const label = tieneAlertas
    ? `Tenés ${total} ${total === 1 ? 'alerta pendiente' : 'alertas pendientes'}`
    : 'No tenés alertas pendientes';

  return (
    <button
      type="button"
      onClick={handleClick}
      title={label}
      aria-label={label}
      className="relative p-2 rounded-full hover:bg-gray-100 transition focus:outline-none focus:ring-2 focus:ring-primary-500"
    >
      <svg
        className={`h-6 w-6 ${tieneAlertas ? 'text-amber-600' : 'text-gray-400'}`}
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        aria-hidden="true"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
        />
      </svg>
      {tieneAlertas && (
        <span className="absolute -top-0.5 -right-0.5 min-w-[1.25rem] h-5 px-1 inline-flex items-center justify-center rounded-full text-xs font-bold bg-red-600 text-white">
          {total > 9 ? '9+' : total}
        </span>
      )}
    </button>
  );
}
